import React, { useMemo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { decode } from 'base64-arraybuffer';
import { Document, Page, pdfjs } from 'react-pdf';
// version is fixed in the package json by removen ^ so it can't change anymore.
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.nallian.io/static/pdfjs/${pdfjs.version}/pdf.worker.js`;

const PdfViewer = ({ content, onReady }) => {
  const [nrPages, setNrPages] = useState();
  const pagesArray = useMemo(
    () =>
      Array.from(new Array(nrPages), (_, index) => (
        <Page
          key={`page_${index + 1}`}
          pageNumber={index + 1}
          scale={0.95}
          onRenderSuccess={onReady}
        />
      )),
    [nrPages, onReady]
  );
  const handleLoadSuccess = useCallback(({ numPages }) => setNrPages(numPages), [setNrPages]);
  const pdf = useMemo(() => (content ? decode(content) : content), [content]);

  return (
    <Document file={pdf} onLoadSuccess={handleLoadSuccess} options={{ isEvalSupported: false }}>
      {pagesArray}
    </Document>
  );
};

PdfViewer.propTypes = {
  content: PropTypes.string.isRequired,
  onReady: PropTypes.func.isRequired,
};

export default PdfViewer;
